import "./product-details-favorite-modal.scss";
import { EventBus, Events } from "jiffy-store";
import initProductDetailsFavoriteModalNote from "../product-details-favorite-modal-note/product-details-favorite-modal-note";

export default () => {
  const modalColor = $(".js-product-details-favorite-modal-color");
  const modalImages = $(".js-product-details-favorite-modal-image");
  const modalPrices = $(".js-product-details-favorite-modal-prices");

  EventBus.on(Events.PRODUCT_COLOR_SELECTED, (evt, { color }) => {
    if (modalColor.length) {
      modalColor.text(color);
    }

    modalImages.each(index => {
      const item = $(modalImages[index]);
      item.toggleClass("hidden", item.data("color-name") !== color);
    });

    modalPrices.each(index => {
      const item = $(modalPrices[index]);
      item.toggleClass("hidden", item.data("color") !== color);
    });
  });

  initProductDetailsFavoriteModalNote();
};
